import useSWRMutation from "swr/mutation";
import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export interface SessionInvitee {
  name?: string;
  surname?: string;
  email?: string;
  role?: string;
  status?: string;
}

interface UseSessionInvitationsArgs {
  corporateId: string | number;
  editionId: string | number;
  sessionId: string | number;
  meetingId?: string | number | null;
  page: number;
  pageSize: number;
  search?: string;
  status?: string;
}

export interface UseSessionInvitationsResult extends PaginatedListResult<SessionInvitee> {
  resend: () => Promise<any>;
  isResending: boolean;
}

export const useSessionInvitations = ({
  corporateId,
  editionId,
  sessionId,
  meetingId,
  page,
  pageSize,
  search,
  status,
}: UseSessionInvitationsArgs): UseSessionInvitationsResult => {
  const url =
    corporateId && (meetingId || sessionId)
      ? meetingId
        ? `${ServicesURL.invitationStatus.replace(
            ":meetingId",
            String(meetingId),
          )}?corporateId=${corporateId}`
        : `${ServicesURL.invitationStatusSession.replace(
            ":sessionId",
            String(sessionId),
          )}?corporateId=${corporateId}`
      : null;

  const list = usePaginatedList<SessionInvitee>(url, {
    page,
    pageSize,
    search,
    searchField: "name",
    fieldFilters: status ? { status } : undefined,
  });

  const { trigger: resend, isMutating: isResending } = useSWRMutation(
    corporateId && editionId && sessionId
      ? `${ServicesURL.resendSessionNotifications
          .replace("{editionId}", String(editionId))
          .replace(
            "{sessionId}",
            String(sessionId),
          )}?corporateId=${corporateId}`
      : null,
    (u: string) => fetcher<any>(u, MethodType.POST),
  );

  return { ...list, resend, isResending };
};

export const getInviteeName = (i: SessionInvitee): string =>
  [i.name, i.surname].filter(Boolean).join(" ").trim() || i.email || "-";
